
import request from '@/utils/request_common'

export const mpsDatasApi = (params: any) =>  request({
  url: '/mps/institutionProviderMpsCommission/datas',
  method: 'post',
  data: params
})

export const mpsInstitutionGroupDatasApi = () => request({
  url: '/mps/institutionProviderMpsCommission/getInstitutionGroupSelect',
  method: 'post'
})

export const mpsInstitutionTypeDatasApi = () => request({
  url: '/mps/institutionProviderMpsCommission/getInstitutionTypeList',
  method: 'post'
})

export const mpsTopCountriesDatasApi= (params: any) => request({
  url: '/mps/institutionProviderMpsCommission/getTopCountries',
  method: 'post',
  data: params
})

export const mpsInstitutionListApi = (params: any) =>  request({
  url: '/mps/institutionProviderMpsCommission/getInstitutionList',
  method: 'post',
  data: params
})

export const mpsSchoolNationalityListApi = () => request({
  url: '/mps/institutionProviderMpsCommission/getAllAreaCountryList',
  method: 'get'
})

export const mpsContractNationalityListApi = () => request({
  url: '/mps/institutionProviderMpsCommission/getAllContractAreaCountryList',
  method: 'get'
})


export const mpsSaveInstitutionClick = (id: number) =>  request({
  url: '/mps/institutionProviderMpsCommission/saveInstitutionClick?institutionId=' + id.toString(),
  method: 'post'
})

// 导出查询列表
export const mpsExportExcelApi = (data: any) =>
  request({
    url: `/mps/institutionProviderMpsCommission/exportMpsExcel`,
    method: 'post',
    data,
    responseType: "blob"
  });
export const mpsLevelExportExcelApi = (data: any) =>
  request({
    url: `/mps/institutionProviderMpsCommission/exportMpsLevelExcel`,
    method: 'post',
    data,
    responseType: "blob"
  });